import { render, staticRenderFns } from "./addLg.vue?vue&type=template&id=06698a5e&scoped=true&"
import script from "./addLg.vue?vue&type=script&lang=js&"
export * from "./addLg.vue?vue&type=script&lang=js&"
import style0 from "./addLg.vue?vue&type=style&index=0&id=06698a5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06698a5e",
  null
  
)

export default component.exports